import { template as _$template } from "solid-js/web";
import { delegateEvents as _$delegateEvents } from "solid-js/web";
import { className as _$className } from "solid-js/web";
import { setStyleProperty as _$setStyleProperty } from "solid-js/web";
import { setAttribute as _$setAttribute } from "solid-js/web";
import { effect as _$effect } from "solid-js/web";
import { memo as _$memo } from "solid-js/web";
import { insert as _$insert } from "solid-js/web";
import { createComponent as _$createComponent } from "solid-js/web";
var _tmpl$ = /*#__PURE__*/_$template(`<div class=space-y-3>`),
  _tmpl$2 = /*#__PURE__*/_$template(`<div class="min-h-screen bg-stone-950 text-stone-100 flex flex-col items-center justify-start px-6 py-16"><div class="w-full max-w-sm">`),
  _tmpl$3 = /*#__PURE__*/_$template(`<div class="h-14 rounded-xl bg-stone-800 animate-pulse">`),
  _tmpl$4 = /*#__PURE__*/_$template(`<p class="text-red-400 text-sm">`),
  _tmpl$5 = /*#__PURE__*/_$template(`<div><div class=mb-10><h1 class="text-2xl font-semibold tracking-tight text-stone-100">Sunday</h1><p class="text-sm text-stone-500 mt-1"></p></div><form class=space-y-4><div><label for=email class="block text-xs text-stone-500 uppercase tracking-widest mb-2">Email</label><input id=email name=email type=email required autocomplete=email class="w-full px-4 py-3 rounded-xl bg-stone-900 border border-stone-700 text-stone-100 text-base placeholder:text-stone-600 focus:outline-none focus:border-stone-500 transition-colors"placeholder=you@example.com></div><div><label for=password class="block text-xs text-stone-500 uppercase tracking-widest mb-2">Password</label><input id=password name=password type=password required minlength=8 class="w-full px-4 py-3 rounded-xl bg-stone-900 border border-stone-700 text-stone-100 text-base placeholder:text-stone-600 focus:outline-none focus:border-stone-500 transition-colors"></div><button type=submit class="w-full py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-stone-950 text-sm font-semibold transition-colors duration-150 disabled:opacity-50 cursor-pointer">`),
  _tmpl$6 = /*#__PURE__*/_$template(`<svg class="w-4 h-4"viewBox="0 0 20 20"fill=currentColor><path fill-rule=evenodd d="M7.84 1.804A1 1 0 018.82 1h2.36a1 1 0 01.98.804l.331 1.652a6.993 6.993 0 011.929 1.115l1.598-.54a1 1 0 011.186.447l1.18 2.044a1 1 0 01-.205 1.251l-1.267 1.113a7.047 7.047 0 010 2.228l1.267 1.113a1 1 0 01.206 1.25l-1.18 2.045a1 1 0 01-1.187.447l-1.598-.54a6.993 6.993 0 01-1.929 1.115l-.33 1.652a1 1 0 01-.98.804H8.82a1 1 0 01-.98-.804l-.331-1.652a6.993 6.993 0 01-1.929-1.115l-1.598.54a1 1 0 01-1.186-.447l-1.18-2.044a1 1 0 01.205-1.251l1.267-1.114a7.05 7.05 0 010-2.227L1.821 7.773a1 1 0 01-.206-1.25l1.18-2.045a1 1 0 011.187-.447l1.598.54A6.993 6.993 0 017.51 3.456l.33-1.652zM10 13a3 3 0 100-6 3 3 0 000 6z"clip-rule=evenodd>`),
  _tmpl$7 = /*#__PURE__*/_$template(`<div class="mb-10 flex items-start justify-between"><div><h1 class="text-2xl font-semibold tracking-tight text-stone-100">Sunday</h1><p class="text-sm text-stone-500 mt-1"></p></div><div class="flex items-center gap-3 mt-1"><button class="text-xs text-stone-600 hover:text-stone-400 transition-colors cursor-pointer"></button><button class="text-xs text-stone-600 hover:text-stone-400 transition-colors cursor-pointer">Sign out`),
  _tmpl$8 = /*#__PURE__*/_$template(`<p class="text-red-400 text-sm">Failed to load. Refresh to try again.`),
  _tmpl$9 = /*#__PURE__*/_$template(`<div class=mb-6><div class="flex justify-between items-baseline mb-2"><span class="text-xs text-stone-500 uppercase tracking-widest">Progress</span><span class="text-xs text-stone-400"> / </span></div><div class="h-1 bg-stone-800 rounded-full overflow-hidden"><div class="h-full bg-emerald-500 rounded-full transition-all duration-500">`),
  _tmpl$0 = /*#__PURE__*/_$template(`<div class="text-center py-12"><p class="text-stone-500 text-sm mb-3">No items on your checklist yet.</p><button class="text-sm text-emerald-400 hover:text-emerald-300 transition-colors cursor-pointer">Add items in settings →`),
  _tmpl$1 = /*#__PURE__*/_$template(`<div class="space-y-2 mb-8">`),
  _tmpl$10 = /*#__PURE__*/_$template(`<p class="text-center text-emerald-400 text-sm font-medium mb-6">You're ready for the week.`),
  _tmpl$11 = /*#__PURE__*/_$template(`<button class="w-full py-3 rounded-xl text-xs text-stone-500 hover:text-stone-300 transition-colors duration-150 disabled:opacity-50 cursor-pointer">`),
  _tmpl$12 = /*#__PURE__*/_$template(`<svg class="w-3 h-3 text-stone-950"viewBox="0 0 12 12"fill=none><path d="M2 6l3 3 5-5"stroke=currentColor stroke-width=2 stroke-linecap=round stroke-linejoin=round>`),
  _tmpl$13 = /*#__PURE__*/_$template(`<button><span></span><span>`),
  _tmpl$14 = /*#__PURE__*/_$template(`<p class="text-xs text-stone-600 mb-6">Changes take effect on next weekly reset, or when you reset manually.`),
  _tmpl$15 = /*#__PURE__*/_$template(`<div class="space-y-2 mb-6">`),
  _tmpl$16 = /*#__PURE__*/_$template(`<p class="text-stone-600 text-sm text-center mb-6">No items yet. Add your first one below.`),
  _tmpl$17 = /*#__PURE__*/_$template(`<form class="flex gap-2"><input type=text placeholder="Add a checklist item…"maxlength=200 class="flex-1 px-4 py-3 rounded-xl bg-stone-900 border border-stone-700 text-stone-100 text-base placeholder:text-stone-600 focus:outline-none focus:border-stone-500 transition-colors"><button type=submit class="px-4 py-3 rounded-xl bg-emerald-600 hover:bg-emerald-500 text-stone-950 text-sm font-semibold transition-colors duration-150 disabled:opacity-50 cursor-pointer">Add`),
  _tmpl$18 = /*#__PURE__*/_$template(`<input type=text autofocus class="flex-1 bg-stone-800 border border-stone-600 rounded-lg px-3 py-1 text-base text-stone-100 focus:outline-none focus:border-stone-400">`),
  _tmpl$19 = /*#__PURE__*/_$template(`<button class="p-1 text-emerald-400 hover:text-emerald-300 transition-colors cursor-pointer"title=Save><svg class="w-3.5 h-3.5"viewBox="0 0 12 12"fill=none stroke=currentColor stroke-width=2 stroke-linecap=round stroke-linejoin=round><path d="M2 6l3 3 5-5">`),
  _tmpl$20 = /*#__PURE__*/_$template(`<button class="p-1 text-stone-600 hover:text-stone-400 transition-colors cursor-pointer"title=Cancel><svg class="w-3.5 h-3.5"viewBox="0 0 12 12"fill=none stroke=currentColor stroke-width=2 stroke-linecap=round stroke-linejoin=round><path d="M3 3l6 6M9 3l-6 6">`),
  _tmpl$21 = /*#__PURE__*/_$template(`<div><span class="text-stone-700 cursor-grab active:cursor-grabbing flex-shrink-0 select-none"title="Drag to reorder"><svg class="w-4 h-4"viewBox="0 0 16 16"fill=currentColor><circle cx=5 cy=4 r=1.5></circle><circle cx=11 cy=4 r=1.5></circle><circle cx=5 cy=8 r=1.5></circle><circle cx=11 cy=8 r=1.5></circle><circle cx=5 cy=12 r=1.5></circle><circle cx=11 cy=12 r=1.5></circle></svg></span><div class="flex items-center gap-1 flex-shrink-0">`),
  _tmpl$22 = /*#__PURE__*/_$template(`<span class="text-sm text-stone-200 flex-1">`),
  _tmpl$23 = /*#__PURE__*/_$template(`<button class="p-1 text-stone-600 hover:text-stone-400 disabled:opacity-30 transition-colors cursor-pointer"title="Move up"><svg class="w-3.5 h-3.5"viewBox="0 0 12 12"fill=none stroke=currentColor stroke-width=2 stroke-linecap=round stroke-linejoin=round><path d="M6 2v8M2 6l4-4 4 4">`),
  _tmpl$24 = /*#__PURE__*/_$template(`<button class="p-1 text-stone-600 hover:text-stone-400 disabled:opacity-30 transition-colors cursor-pointer"title="Move down"><svg class="w-3.5 h-3.5"viewBox="0 0 12 12"fill=none stroke=currentColor stroke-width=2 stroke-linecap=round stroke-linejoin=round><path d="M6 10V2M2 6l4 4 4-4">`),
  _tmpl$25 = /*#__PURE__*/_$template(`<button class="p-1 text-stone-600 hover:text-stone-400 transition-colors cursor-pointer"title=Edit><svg class="w-3.5 h-3.5"viewBox="0 0 12 12"fill=none stroke=currentColor stroke-width=1.5 stroke-linecap=round stroke-linejoin=round><path d="M8.5 1.5l2 2L4 10H2v-2l6.5-6.5z">`),
  _tmpl$26 = /*#__PURE__*/_$template(`<button class="p-1 text-stone-600 hover:text-red-400 transition-colors cursor-pointer"title=Delete><svg class="w-3.5 h-3.5"viewBox="0 0 12 12"fill=none stroke=currentColor stroke-width=1.5 stroke-linecap=round stroke-linejoin=round><path d="M2 3h8M4 3V2h4v1M5 5v4M7 5v4M3 3l.5 7h5l.5-7">`);
/** @jsxImportSource solid-js */
import { createResource, createSignal, For, Show } from 'solid-js';

// --- Types ---

// --- API helpers ---

async function fetchMe() {
  const res = await fetch('/api/auth/me');
  if (!res.ok) return {
    authenticated: false,
    registrationOpen: false
  };
  const json = await res.json();
  return json.data;
}
async function fetchChecklist() {
  const res = await fetch('/api/checklist');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await res.json();
  return json.data;
}
async function fetchTemplates() {
  const res = await fetch('/api/templates');
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const json = await res.json();
  return json.data.templates;
}

// --- App ---

export default function App() {
  const [authState, {
    mutate: mutateAuth,
    refetch: refetchAuth
  }] = createResource(fetchMe);
  const isLoggedIn = () => authState()?.authenticated === true;
  const isRegistering = () => authState()?.registrationOpen === true;
  return (() => {
    var _el$ = _tmpl$2(),
      _el$2 = _el$.firstChild;
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return authState.loading;
      },
      get children() {
        var _el$3 = _tmpl$();
        _$insert(_el$3, _$createComponent(For, {
          each: [1, 2, 3, 4],
          children: () => _tmpl$3()
        }));
        return _el$3;
      }
    }), null);
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return _$memo(() => !!!authState.loading)() && !isLoggedIn();
      },
      get children() {
        return _$createComponent(AuthForm, {
          get isRegister() {
            return isRegistering();
          },
          onSuccess: () => refetchAuth()
        });
      }
    }), null);
    _$insert(_el$2, _$createComponent(Show, {
      get when() {
        return isLoggedIn();
      },
      get children() {
        return _$createComponent(Checklist, {
          get email() {
            return authState().user.email;
          },
          onLogout: () => mutateAuth({
            authenticated: false,
            registrationOpen: false
          })
        });
      }
    }), null);
    return _el$;
  })();
}

// --- Auth Form ---

function AuthForm(props) {
  const [email, setEmail] = createSignal('');
  const [password, setPassword] = createSignal('');
  const [error, setError] = createSignal('');
  const [loading, setLoading] = createSignal(false);
  async function submit(e) {
    e.preventDefault();
    setError('');
    setLoading(true);
    const endpoint = props.isRegister ? '/api/auth/register' : '/api/auth/login';
    try {
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          email: email(),
          password: password()
        })
      });
      const json = await res.json();
      if (!res.ok) {
        setError(json.message || 'Something went wrong');
        return;
      }
      props.onSuccess();
    } catch {
      setError('Network error — try again');
    } finally {
      setLoading(false);
    }
  }
  return (() => {
    var _el$5 = _tmpl$5(),
      _el$6 = _el$5.firstChild,
      _el$7 = _el$6.firstChild,
      _el$8 = _el$7.nextSibling,
      _el$9 = _el$6.nextSibling,
      _el$0 = _el$9.firstChild,
      _el$1 = _el$0.firstChild,
      _el$10 = _el$1.nextSibling,
      _el$11 = _el$0.nextSibling,
      _el$12 = _el$11.firstChild,
      _el$13 = _el$12.nextSibling,
      _el$15 = _el$11.nextSibling;
    _$insert(_el$8, () => props.isRegister ? 'Create your account to get started.' : 'Sign in to your checklist.');
    _el$9.addEventListener("submit", submit);
    _el$10.$$input = e => setEmail(e.currentTarget.value);
    _el$13.$$input = e => setPassword(e.currentTarget.value);
    _$insert(_el$9, _$createComponent(Show, {
      get when() {
        return error();
      },
      get children() {
        var _el$14 = _tmpl$4();
        _$insert(_el$14, error);
        return _el$14;
      }
    }), _el$15);
    _$insert(_el$15, (() => {
      var _c$ = _$memo(() => !!loading());
      return () => _c$() ? props.isRegister ? 'Creating account…' : 'Signing in…' : props.isRegister ? 'Create account' : 'Sign in';
    })());
    _$effect(_p$ => {
      var _v$ = props.isRegister ? 'new-password' : 'current-password',
        _v$2 = props.isRegister ? 'Min. 8 characters' : '••••••••',
        _v$3 = loading();
      _v$ !== _p$.e && _$setAttribute(_el$13, "autocomplete", _p$.e = _v$);
      _v$2 !== _p$.t && _$setAttribute(_el$13, "placeholder", _p$.t = _v$2);
      _v$3 !== _p$.a && (_el$15.disabled = _p$.a = _v$3);
      return _p$;
    }, {
      e: undefined,
      t: undefined,
      a: undefined
    });
    _$effect(() => _el$10.value = email());
    _$effect(() => _el$13.value = password());
    return _el$5;
  })();
}

// --- Checklist ---

function Checklist(props) {
  const [checklist, {
    mutate,
    refetch: refetchChecklist
  }] = createResource(fetchChecklist);
  const [resetting, setResetting] = createSignal(false);
  const [view, setView] = createSignal('checklist');
  async function toggle(id) {
    const res = await fetch(`/api/checklist/items/${id}/toggle`, {
      method: 'POST'
    });
    if (!res.ok) return;
    const json = await res.json();
    const updated = json.data.item;
    mutate(prev => {
      if (!prev) return prev;
      return {
        ...prev,
        items: prev.items.map(i => i.id === updated.id ? updated : i),
        progress: {
          total: prev.progress.total,
          checked: prev.items.map(i => i.id === updated.id ? updated : i).filter(i => i.checked).length
        }
      };
    });
  }
  async function reset() {
    setResetting(true);
    const res = await fetch('/api/checklist/reset', {
      method: 'POST'
    });
    if (res.ok) {
      const json = await res.json();
      mutate(json.data);
    }
    setResetting(false);
  }
  async function logout() {
    await fetch('/api/auth/logout', {
      method: 'POST'
    });
    props.onLogout();
  }
  const allDone = () => {
    const c = checklist();
    return c ? c.progress.checked === c.progress.total && c.progress.total > 0 : false;
  };
  return [(() => {
    var _el$16 = _tmpl$7(),
      _el$17 = _el$16.firstChild,
      _el$18 = _el$17.firstChild,
      _el$19 = _el$18.nextSibling,
      _el$20 = _el$17.nextSibling,
      _el$21 = _el$20.firstChild,
      _el$23 = _el$21.nextSibling;
    _$insert(_el$19, _$createComponent(Show, {
      get when() {
        return view() === 'checklist';
      },
      get children() {
        return new Date().toLocaleDateString('en-US', {
          weekday: 'long',
          month: 'long',
          day: 'numeric'
        });
      }
    }), null);
    _$insert(_el$19, _$createComponent(Show, {
      get when() {
        return view() === 'settings';
      },
      children: "Configure your checklist items"
    }), null);
    _el$21.$$click = () => {
      if (view() === 'settings') {
        // Returning to checklist — refetch in case templates changed
        refetchChecklist();
      }
      setView(view() === 'checklist' ? 'settings' : 'checklist');
    };
    _$insert(_el$21, _$createComponent(Show, {
      get when() {
        return view() === 'checklist';
      },
      get children() {
        return _tmpl$6();
      }
    }), null);
    _$insert(_el$21, _$createComponent(Show, {
      get when() {
        return view() === 'settings';
      },
      children: "\u2190 Back"
    }), null);
    _el$23.$$click = logout;
    _$effect(_p$ => {
      var _v$4 = view() === 'checklist' ? 'Settings' : 'Back to checklist',
        _v$5 = props.email;
      _v$4 !== _p$.e && _$setAttribute(_el$21, "title", _p$.e = _v$4);
      _v$5 !== _p$.t && _$setAttribute(_el$23, "title", _p$.t = _v$5);
      return _p$;
    }, {
      e: undefined,
      t: undefined
    });
    return _el$16;
  })(), _$createComponent(Show, {
    get when() {
      return view() === 'checklist';
    },
    get children() {
      return [_$createComponent(Show, {
        get when() {
          return checklist.loading;
        },
        get children() {
          var _el$24 = _tmpl$();
          _$insert(_el$24, _$createComponent(For, {
            each: [1, 2, 3, 4],
            children: () => _tmpl$3()
          }));
          return _el$24;
        }
      }), _$createComponent(Show, {
        get when() {
          return checklist.error;
        },
        get children() {
          return _tmpl$8();
        }
      }), _$createComponent(Show, {
        get when() {
          return checklist();
        },
        children: data => [(() => {
          var _el$27 = _tmpl$9(),
            _el$28 = _el$27.firstChild,
            _el$29 = _el$28.firstChild,
            _el$30 = _el$29.nextSibling,
            _el$31 = _el$30.firstChild,
            _el$32 = _el$28.nextSibling,
            _el$33 = _el$32.firstChild;
          _$insert(_el$30, () => data().progress.checked, _el$31);
          _$insert(_el$30, () => data().progress.total, null);
          _$effect(_$p => _$setStyleProperty(_el$33, "width", `${data().progress.total > 0 ? data().progress.checked / data().progress.total * 100 : 0}%`));
          return _el$27;
        })(), _$createComponent(Show, {
          get when() {
            return data().items.length === 0;
          },
          get children() {
            var _el$34 = _tmpl$0(),
              _el$35 = _el$34.firstChild,
              _el$36 = _el$35.nextSibling;
            _el$36.$$click = () => setView('settings');
            return _el$34;
          }
        }), (() => {
          var _el$37 = _tmpl$1();
          _$insert(_el$37, _$createComponent(For, {
            get each() {
              return data().items;
            },
            children: item => (() => {
              var _el$40 = _tmpl$13(),
                _el$41 = _el$40.firstChild,
                _el$43 = _el$41.nextSibling;
              _el$40.$$click = () => toggle(item.id);
              _$insert(_el$41, _$createComponent(Show, {
                get when() {
                  return item.checked;
                },
                get children() {
                  return _tmpl$12();
                }
              }));
              _$insert(_el$43, () => item.label);
              _$effect(_p$ => {
                var _v$6 = `w-full flex items-center gap-4 px-4 py-4 rounded-xl border transition-all duration-150 text-left cursor-pointer
                        ${item.checked ? 'bg-stone-900 border-stone-800 opacity-50' : 'bg-stone-900 border-stone-700 hover:border-stone-500'}`,
                  _v$7 = `w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all duration-150
                          ${item.checked ? 'bg-emerald-500 border-emerald-500' : 'border-stone-600'}`,
                  _v$8 = `text-sm font-medium transition-all duration-150
                          ${item.checked ? 'line-through text-stone-600' : 'text-stone-200'}`;
                _v$6 !== _p$.e && _$className(_el$40, _p$.e = _v$6);
                _v$7 !== _p$.t && _$className(_el$41, _p$.t = _v$7);
                _v$8 !== _p$.a && _$className(_el$43, _p$.a = _v$8);
                return _p$;
              }, {
                e: undefined,
                t: undefined,
                a: undefined
              });
              return _el$40;
            })()
          }));
          return _el$37;
        })(), _$createComponent(Show, {
          get when() {
            return allDone();
          },
          get children() {
            return _tmpl$10();
          }
        }), (() => {
          var _el$39 = _tmpl$11();
          _el$39.$$click = reset;
          _$insert(_el$39, () => resetting() ? 'Resetting…' : 'Reset checklist');
          _$effect(() => _el$39.disabled = resetting());
          return _el$39;
        })()]
      })];
    }
  }), _$createComponent(Show, {
    get when() {
      return view() === 'settings';
    },
    get children() {
      return _$createComponent(TemplateSettings, {});
    }
  })];
}

// --- Template Settings ---

function TemplateSettings() {
  const [templates, {
    mutate,
    refetch
  }] = createResource(fetchTemplates);
  const [newLabel, setNewLabel] = createSignal('');
  const [editingId, setEditingId] = createSignal(null);
  const [editingLabel, setEditingLabel] = createSignal('');
  const [saving, setSaving] = createSignal(false);
  const [draggedId, setDraggedId] = createSignal(null);
  async function addItem(e) {
    e.preventDefault();
    const label = newLabel().trim();
    if (!label) return;
    setSaving(true);
    try {
      const res = await fetch('/api/templates', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          label
        })
      });
      if (res.ok) {
        const json = await res.json();
        mutate(prev => prev ? [...prev, json.data.template] : [json.data.template]);
        setNewLabel('');
      }
    } finally {
      setSaving(false);
    }
  }
  async function saveEdit(id) {
    const label = editingLabel().trim();
    if (!label) return;
    const res = await fetch('/api/templates', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id,
        label
      })
    });
    if (res.ok) {
      const json = await res.json();
      mutate(prev => prev?.map(t => t.id === id ? json.data.template : t));
    }
    setEditingId(null);
    setEditingLabel('');
  }
  async function deleteItem(id) {
    const res = await fetch(`/api/templates/${id}/delete`, {
      method: 'POST'
    });
    if (res.ok) {
      mutate(prev => prev?.filter(t => t.id !== id));
    }
  }
  function startEdit(item) {
    setEditingId(item.id);
    setEditingLabel(item.label);
  }
  function cancelEdit() {
    setEditingId(null);
    setEditingLabel('');
  }
  async function moveItem(id, direction) {
    const current = templates();
    if (!current) return;
    const idx = current.findIndex(t => t.id === id);
    const targetIdx = idx + direction;
    if (targetIdx < 0 || targetIdx >= current.length) return;
    const newOrder = [...current];
    const [moved] = newOrder.splice(idx, 1);
    newOrder.splice(targetIdx, 0, moved);

    // Optimistic update
    mutate(newOrder);

    // Persist
    await fetch('/api/templates/reorder', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        order: newOrder.map(t => t.id)
      })
    });
  }

  // --- Drag & drop ---
  function handleDragStart(id) {
    setDraggedId(id);
  }
  function handleDragOver(e, targetId) {
    e.preventDefault();
    const dragged = draggedId();
    if (dragged == null || dragged === targetId) return;
    const current = templates();
    if (!current) return;
    const fromIdx = current.findIndex(t => t.id === dragged);
    const toIdx = current.findIndex(t => t.id === targetId);
    if (fromIdx === -1 || toIdx === -1) return;
    const newOrder = [...current];
    const [moved] = newOrder.splice(fromIdx, 1);
    newOrder.splice(toIdx, 0, moved);
    mutate(newOrder);
  }
  async function handleDragEnd() {
    const current = templates();
    setDraggedId(null);
    if (!current) return;
    await fetch('/api/templates/reorder', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        order: current.map(t => t.id)
      })
    });
  }
  return [_$createComponent(Show, {
    get when() {
      return templates.loading;
    },
    get children() {
      var _el$44 = _tmpl$();
      _$insert(_el$44, _$createComponent(For, {
        each: [1, 2, 3],
        children: () => _tmpl$3()
      }));
      return _el$44;
    }
  }), _$createComponent(Show, {
    get when() {
      return templates();
    },
    children: items => [_tmpl$14(), (() => {
      var _el$47 = _tmpl$15();
      _$insert(_el$47, _$createComponent(For, {
        get each() {
          return items();
        },
        children: (item, index) => (() => {
          var _el$52 = _tmpl$21(),
            _el$53 = _el$52.firstChild,
            _el$55 = _el$53.nextSibling;
          _el$52.addEventListener("dragend", () => handleDragEnd());
          _el$52.addEventListener("dragover", e => handleDragOver(e, item.id));
          _el$52.addEventListener("dragstart", () => handleDragStart(item.id));
          _$insert(_el$52, _$createComponent(Show, {
            get when() {
              return editingId() === item.id;
            },
            get fallback() {
              return (() => {
                var _el$58 = _tmpl$22();
                _$insert(_el$58, () => item.label);
                return _el$58;
              })();
            },
            get children() {
              var _el$54 = _tmpl$18();
              _el$54.$$keydown = e => {
                if (e.key === 'Enter') saveEdit(item.id);
                if (e.key === 'Escape') cancelEdit();
              };
              _el$54.$$input = e => setEditingLabel(e.currentTarget.value);
              _$effect(() => _el$54.value = editingLabel());
              return _el$54;
            }
          }), _el$55);
          _$insert(_el$55, _$createComponent(Show, {
            get when() {
              return editingId() === item.id;
            },
            get fallback() {
              return [(() => {
                var _el$59 = _tmpl$23();
                _el$59.$$click = () => moveItem(item.id, -1);
                _$effect(() => _el$59.disabled = index() === 0);
                return _el$59;
              })(), (() => {
                var _el$60 = _tmpl$24();
                _el$60.$$click = () => moveItem(item.id, 1);
                _$effect(() => _el$60.disabled = index() === items().length - 1);
                return _el$60;
              })(), (() => {
                var _el$61 = _tmpl$25();
                _el$61.$$click = () => startEdit(item);
                return _el$61;
              })(), (() => {
                var _el$62 = _tmpl$26();
                _el$62.$$click = () => deleteItem(item.id);
                return _el$62;
              })()];
            },
            get children() {
              return [(() => {
                var _el$56 = _tmpl$19();
                _el$56.$$click = () => saveEdit(item.id);
                return _el$56;
              })(), (() => {
                var _el$57 = _tmpl$20();
                _el$57.$$click = cancelEdit;
                return _el$57;
              })()];
            }
          }));
          _$effect(_p$ => {
            var _v$9 = `flex items-center gap-2 px-4 py-3 rounded-xl bg-stone-900 border transition-all duration-150
                      ${draggedId() === item.id ? 'border-emerald-500 opacity-70' : 'border-stone-800'}`,
              _v$0 = editingId() !== item.id;
            _v$9 !== _p$.e && _$className(_el$52, _p$.e = _v$9);
            _v$0 !== _p$.t && _$setAttribute(_el$52, "draggable", _p$.t = _v$0);
            return _p$;
          }, {
            e: undefined,
            t: undefined
          });
          return _el$52;
        })()
      }));
      return _el$47;
    })(), _$createComponent(Show, {
      get when() {
        return items().length === 0;
      },
      get children() {
        return _tmpl$16();
      }
    }), (() => {
      var _el$49 = _tmpl$17(),
        _el$50 = _el$49.firstChild,
        _el$51 = _el$50.nextSibling;
      _el$49.addEventListener("submit", addItem);
      _el$50.$$input = e => setNewLabel(e.currentTarget.value);
      _$effect(() => _el$51.disabled = saving() || !newLabel().trim());
      _$effect(() => _el$50.value = newLabel());
      return _el$49;
    })()]
  })];
}
_$delegateEvents(["input", "click", "keydown"]);